module.exports = __webpack_public_path__ + "static/media/kredyt_13.ac935bd2.png";